import React from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import { PortalNavigate } from './PortalNavigate'
import { LayoutAdmin } from '../layouts/Admin/Admin'
import TutorialsList from '../pages/tutorials/TutorialsList'
import { RouteRoleGuard } from '../layouts/RouteRoleGuard/RouteRoleGuard'

import ProListing from '../pages/pro/Listing'
import ProDetails from '../pages/pro/ProDetails'
import MyProfile from '../pages/profile/MyProfile'

import BrandSettingsProfile from '../pages/brand/settings/Profile'
import BrandSettingsResetPassword from '../pages/brand/settings/ResetPassword'
import BrandSettingsInvite from '../pages/brand/settings/Invite'
import BrandSettingsUpdateEmail from '../pages/brand/settings/UpdateEmail'
import BrandSettingsPayments from '../pages/brand/settings/Payments'
import BrandSettings from '../pages/brand/settings/Settings'
import BrandNotificationSettings from '../pages/brand/settings/notification/Notification'
import Onboarding from '../pages/brand/settings/onboarding/Onboarding'
import SearchConsole from '../pages/brand/settings/SearchConsole'
import ApiKeysPage from '../pages/brand/settings/apiKeys/ApiKeysPage'
import { BrandTeamSettings } from '../pages/brand/settings/team/Team'
import { EmbedListing } from '../pages/admin/embeds/Embeds'
import { VideoUGC } from '../pages/admin/videos/UGC/video'
import { VideoXGC } from '../pages/admin/videos/XGC/video'
import { VideoTDC } from '../pages/admin/videos/TDC/video'
import { Upgrade } from '../components/Upgrade/Upgrade'
import SingleProProfile from '../components/singlePro'
import { BrandTeamCreateProjectDistribution, ExpertProfilePath, BrandProPaths } from '../components/Header/configuration/navs'
import { NetworkRouteChildren } from './networkRoutes'
import { ExpertsV2Listing } from '../pages/brand/expertsV2/Experts'
import { EmbedV2Listing } from '../pages/admin/embeds/embedsV2'
import { VideoTDCV2 } from '../pages/admin/videos/TDC/videoV2'
import { VideoListingV2 } from '../pages/admin/videos/VideosV2'
import VideoProduction from '../pages/videoProduction/VideoProduction'
import ExpertSelection from '../pages/videoProduction/expertSelection'
import OrdersPage from '../pages/orders'
import Dashboard from '../pages/dashboard'


export const BrandMemberRoutesTDC: RouteObject[] = [
  {
    path: '/',
    element: (
      <RouteRoleGuard role="BRAND_MEMBER">
        <LayoutAdmin />
      </RouteRoleGuard>
    ),
    children: [
      ...BrandProPaths,
      ...ExpertProfilePath,
      {
        path: '/experts/featured',
        element: <ExpertsV2Listing />,
      },
      ...BrandTeamCreateProjectDistribution,
      ...NetworkRouteChildren,
      {
        path: '',
        index: true,
        // element: <ValidateProfile validateRoute="/videos" invalidateRoute="/brand/projects" />,
        element: <PortalNavigate to="/dashboard" />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: '/videos',
        element: <VideoListingV2 />,
        children: [
          {
            path: '',
            element: <PortalNavigate to="/videos/tdc" />,
          },
          {
            path: 'ugc',
            element: <VideoUGC />,
          },
          {
            path: 'xgc',
            element: <VideoXGC />,
          },
          {
            path: 'tdc',
            element: <VideoTDCV2 />,
          },
        ],
      },
      {
        path: '/video-production/projects',
        element: <VideoProduction />,
      },
      {
        path: '/video-production/orders',
        element: <OrdersPage />,
      },
      {
        path: '/video-production/projects/:projectId',
        element: <ExpertSelection/>,
      },
      {
        path: '/videos/embeds',
        element: <EmbedV2Listing />,
      },
      // {
      //   path: '/expert/:id/:slug',
      //   element: <SingleProProfile />,
      // },
  
      // {
      //     path: 'brand/onboarding',
      //     element: <BrandOnboarding />,
      // },
      // {
      //   path: 'browse/pros',
      //   element: <ProListing />,
      // },
      // {
      //     path: 'brand/projects',
      //     element: <BrandProjects />,
      // },
      // {
      //     path: 'brand/favorites',
      //     element: <Favorites />,
      // },
      // {
      //     path: 'faq',
      //     element: <FAQ />,
      // },
      // {
      // {
      //   path: '/profile/me',
      //   element: <Navigate to="/settings/profile" />,
      // },
      // {
      //   path: 'pros/:id/:slug',
      //   element: <SingleProProfile />,
      // },
      {
        path: '/settings/*',
        element: <BrandSettings />,
        children: [
          {
            // The portal's settings landing is a BRAND tab; the personal ones
            // live at the root (TDC-1609).
            path: '',
            element: <Navigate to="notifications" replace />,
          },
          {
            path: 'profile',
            // Personal tab — canonical at the root.
            element: <Navigate to="/settings/profile" replace />,
          },
          {
            path: 'reset-password',
            // Personal tab — canonical at the root.
            element: <Navigate to="/settings/reset-password" replace />,
          },
          {
            path: 'sign-in-methods',
            // Personal tab — canonical at the root.
            element: <Navigate to="/settings/sign-in-methods" replace />,
          },
          {
            path: 'update-email',
            // Personal tab — canonical at the root.
            element: <Navigate to="/settings/update-email" replace />,
          },
          {
            path: 'notifications',
            element: <BrandNotificationSettings />,
          },
          {
            // Site tag + Shopify pixel + install check (was the Google Tag tab).
            path: 'onboarding',
            element: <Onboarding />,
          },
          {
            path: 'google-tag',
            element: <Navigate to="../onboarding" replace />,
          },
          {
            path: 'search-console',
            element: <SearchConsole />,
          },
          {
            path: 'api-keys',
            element: <ApiKeysPage />,
          },
          {
            path: '*',
            element: <Navigate to="/404" />,
          },
        ],
      },
      {
        path: 'tutorials',
        element: <TutorialsList />,
      },
      {
        path: '*',
        element: <Navigate to="/404" />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/404" />,
  },
]
